import { StudentAbsence } from "@godalming/api-types";
import { portalApi } from "@services/api/portalApi";

export async function getStudentAbsencesByStudentNo(studentNo: string) {
    try {
        const response = await portalApi.get<StudentAbsence[]>(`students/${studentNo}/absences`);
        return response.data
    } catch (error) {
        console.error("Error fetching student absences:", error);
        throw error;
    }
}

type AttendanceStreak = {
    lastAbsenceDate: string | null;
    lastAbsenceMark: string | null;
    presentMarksSinceLastAbsence: number;
}

export async function getStudentAttendanceStreak(studentNo: string) {
    try {
        const response = await portalApi.get<AttendanceStreak>(`/students/${studentNo}/attendance-streak`);
        console.log("Fetched attendance streak:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error fetching student's attendance streak:", error);
        throw error;
    }
}
